<template>
  <div>
    <van-form @submit="onSubmit">
      <van-field
          v-if="show"
          v-model="phone"
          required
          clearable
          label="手机号:"
          :rules="[{ required: true}]"
          placeholder="请输入手机号"
      />
      <van-field
          v-if="show"
          v-model="msgCode"
          center
          required
          clearable
          label="短信验证码"
          placeholder="请输入短信验证码"
          :rules="[{ required: true}]"
      >
        <template #button>
          <van-button :disabled="disabled" size="small" type="primary" @click.prevent="sendCode">{{ tip }}</van-button>
        </template>
      </van-field>
      <van-field
          v-model="name"
          label="姓名:"
          required
          clearable
          :rules="[{ required: true}]"
          placeholder="请输入姓名"
      />
      <van-field name="fileList" label="订单截图" required  :rules="[{ required: true}]">
        <template #input>
          <van-uploader
            multiple
            v-model="fileList"
            :before-delete="beforeDelete"
            :deletable="true"
            :max-size="1000 * 1024" 
            @oversize="onOversize"
            :after-read="checkUpload"
          />
        </template>
      </van-field>
      <van-field
          v-model="message"
          autosize
          clearable
          label="备注"
          type="textarea"
          placeholder="请输入备注"
      />
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit"
        >提交
        </van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import URL from "@/api/api";
import {Toast} from "vant";
import {UrlSearch} from '@/utils/utils';

export default {
  data() {
    return {
      show: true,
      openid: "",
      phone: "",
      msgCode: "",
      name: "",
      message: "", // 备注
      fileList: [],
      returnFileList: [],
      count: '',
      timer: null,
      disabled: false,
      tip: "发送验证码"
    };
  },
  mounted() {
    this.openid = UrlSearch().openid
    if (!this.openid) {
      this.getCustomerCodeUrl()
    }
    this.checkPhone()
  },
  methods: {
    getCustomerCodeUrl() {
      if (!this.openid) {
        this.$fetchGet(URL.singleCode.url).then(res => {
          if (res.data.code == 20000) {
            window.location.href = res.data.data
          }
        });
      }
    },
    sendCode() {
      let data = {
        type: 5,
        phoneNumber: this.phone
      }
      let phoneNo = /^1[3456789]\d{9}$/
      if (!phoneNo.test(this.phone)) {
        Toast('请输入正确手机号')
      } else {
        this.$fetchGet(URL.sendCode.url, data).then((res) => {
          if (!this.timer) {
            this.count = 60
            this.timer = setInterval(() => {
              this.disabled = true
              if (this.count >= 0 && this.count <= 60) {
                this.tip = this.count-- + ' ' + 's'
              } else {
                this.disabled = false
                this.tip = '发送验证码'
                clearInterval(this.timer)
                this.timer = null
              }
            }, 1000)
          }
        });
      }
    },
    onOversize(file) {
      Toast('文件大小不能超过 10MB');
    },
    beforeDelete(file, fileList) {
      this.fileList.splice(fileList.index, 1)
      let imgId = this.returnFileList.splice(fileList.index, 1)
      this.$fetchGet(URL.removeFile.url, {"fileId": Number(imgId)}).then((res) => {
      });
    },
    //拿到openid 判断手机号是否存储过 存过就不用发短信
    checkPhone(){
      this.$fetchPost(URL.checkOpenid.url + this.openid).then(res => {
        if (res.data.code == 20000) {
          // 已近绑定过手机号 不显示手机号和验证码框
          this.show = false;
        }
      })
    },
    checkUpload(file,fileList) {
      let data = new FormData();
      //file是当前file对象, 此对象包含file和content
      data.append("file", file.file);
      data.append("bucketName", '');
      this.$fetchPost(URL.uploadmessageImg.url, data).then((res) => {
        if (res.data.code == 20000) {
          Toast("上传成功!");
        } else {
          Toast("上传失败,请稍后再试!");
          this.fileList.splice(fileList.index, 1)
        }
        this.returnFileList.push(res.data.data.id);
      });
    },
    onSubmit(values) {
      let data = {
        openid: this.openid,
        phone: this.phone, //手机号
        msgCode: this.msgCode, //验证码
        name: this.name, //姓名
        tips: this.message, //备注
        imgIds: this.returnFileList, //图片id集合
        flag: "menu"
      };
      this.$fetchPost(URL.createOrders.url, data).then((res) => {
        if (res.data.code == 20000) {
          Toast(res.data.msg);
          this.$router.push("/");
        } else {
          Toast(res.data.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.van-tab__pane {
  width: 95%;
  margin: 10px auto;
}

.van-card__title {
  max-height: 32px;
  font-weight: 600;
  line-height: 40px;
  font-size: 16px;
}

.dropdown-sty {
  width: 100%;
  display: flex;
  background: #fff;
}

.pro-tit {
  line-height: 50px;
  padding-left: 10px;
  font-size: 16px;
}

.van-dropdown-menu {
  /* width: 70%; */
}

.pro-sty >>> .van-dropdown-menu__bar {
  align-items: start;
  background-color: transparent;
  box-shadow: none;
}

.van-dropdown-menu__bar {
}
</style>
